import { Pipe, PipeTransform } from '@angular/core';
import { getActivityTitle } from './activity.functions';

@Pipe({
  name: 'activityTitle'
})
export class ActivityTitlePipe implements PipeTransform {
    transform(activity?: any): string {
        return getActivityTitle(activity);
    }
};